import { forwardRef, InjectionToken, Type } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

import { Formatter } from './formatter';
import { InputKeyboardEventMatcher } from './matcher';
import { Parser } from './parser';

export interface InputTypeConfig {
  parser: Parser;
  formatter: Formatter;
  validator: ValidatorFn;
  isKeyAllowed: InputKeyboardEventMatcher;
}

export const InputTypeConfigToken = new InjectionToken<InputTypeConfig>('pcsInputTypeConfig');

interface PcsInputTypeProvider<T> {
  provide: InjectionToken<InputTypeConfig>;
  useExisting: Type<T>;
  multi: boolean;
}

export function pcsInputTypeProvider<T extends InputTypeConfig>(type: Type<T>): PcsInputTypeProvider<T> {
  return {
    provide: InputTypeConfigToken,
    useExisting: forwardRef(() => type),
    multi: false
  };
}
